import { api } from './index';

export const pushSubscriptionsApi = {
  create(userId: number, subscription: PushSubscriptionJSON) {
    const path = '/api/internal/push_subscriptions';

    return api({
      method: 'post',
      url: path,
      data: { userId, subscription },
    });
  },
};
